import { css } from '@emotion/react';
import type { Theme } from '@emotion/react';

import { styleUtils } from '@twistopayments/design-system/styles';
import type { CurrencyPosition } from '@twistopayments/design-system/utils';

export const text = (theme: Theme, position: CurrencyPosition) => css`
  color: ${theme.palette.tertiary.mediumContrastAlternative};
  font-weight: ${styleUtils.fontWeight.medium};
  font-size: 16px;
  line-height: 24px;
  margin-left: ${position === 'end' ? theme.spacing[8] : 0};
  margin-right: ${position === 'start' ? theme.spacing[8] : 0};
`;

export const disabled = (theme: Theme) => css`
  color: ${theme.palette.ghost.mediumContrast};
`;
